import { useState, useEffect } from 'react';
import { api } from '../api';
import { useAuth } from '../contexts/AuthContext';

/**
 * Fetch the authenticated user's profile (role, org) from the backend.
 * Returns { profile, loading, error }.
 */
export function useUserProfile() {
  const { user, token } = useAuth();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!user || !token) {
      setLoading(false);
      return;
    }

    let cancelled = false;

    async function fetch() {
      try {
        const data = await api.get('/auth/me');
        if (!cancelled) setProfile(data);
      } catch (err) {
        if (!cancelled) setError(err.message);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    fetch();
    return () => { cancelled = true; };
  }, [user, token]);

  return { profile, loading, error };
}
